import type { ReactNode } from 'react';

import { TenantAttendanceMetricsProvider } from './TenantAttendanceMetricsContext';
import { TenantPressureMetricsProvider } from './TenantPressureMetricsContext';
import { TenantUsageMetricsProvider } from './TenantUsageMetricsContext';

/**
 * Compose tenant-scoped shell providers behind one stable boundary.
 *
 * The provider intentionally keeps the live contracts split by domain:
 * pressure, attendance, and usage still own independent hooks, permissions,
 * websocket streams, and recovery paths. This wrapper only reduces provider
 * nesting in the app shell and gives the tree one tenant-scoped entrypoint
 * for future shared tenant concerns that may not be metrics-specific.
 */
export function TenantProvider({ children }: { children: ReactNode }) {
  return (
    <TenantPressureMetricsProvider>
      <TenantAttendanceMetricsProvider>
        <TenantUsageMetricsProvider>
          {children}
        </TenantUsageMetricsProvider>
      </TenantAttendanceMetricsProvider>
    </TenantPressureMetricsProvider>
  );
}

export default TenantProvider;
